<template>
	<div class="page wrapper">
		<h1 class="pd-l-20 pd-r-20 tx-ct fz-26 fw-7">Nepotistic Or Not?</h1>
		<div class="tx-ct pd-l-20 pd-r-20 fz-12">Swipe to rate</div>
	    <Tinder ref="tinder" key-name="id" :queue.sync="queue" :offset-y="10" @submit="ratingSubmit">
			<template slot-scope="scope">
				<MovieCard :imageBase="imageBase" :movie="scope.data" />
			</template>
			<div class="like-pointer dp-fx fx-al-ct fx-js-ct pos-abs" slot="like"><div class="box"><img src="@/assets/heart-broken.png" width=22><span class="cl-white fw-9 fz-24 mg-l-10">+1</span></div></div>
			<div class="nope-pointer dp-fx fx-al-ct fx-js-ct pos-abs" slot="nope"><div class="box"><img src="@/assets/heart.png" width=22><span class="cl-white fw-9 fz-24 mg-l-10">-1</span></div></div>
	    </Tinder>
		<div class="bottom-tray dp-fx fx-js-ct fx-al-ct">
			<div class="wd-full dp-fx fx-al-ct fx-js-ar">
				<TwitterShareButton :data="twitterShare"/>
				<div class="btn-nope">
					<AgainstButton v-on:against-button-clicked="decide('nope')"/>
				</div>
				<div class="btn-like">
					<SupportButton v-on:support-button-clicked="decide('like')"/>
				</div>
				<CommentButton v-on:comment-button-clicked="commentButtonClicked"/>
			</div>
		</div>
		<CommentsModal />
	</div>
</template>

<script>
	import axios from "axios";
	import Tinder from 'vue-tinder'
	import firebase from 'firebase'
	import MovieCard from "@/components/MovieCard.vue"
	import {mapState} from 'vuex'
	// import source from "@/data/movies";
	import SupportButton from "@/components/SupportButton.vue";
	import AgainstButton from "@/components/AgainstButton.vue";
	import TwitterShareButton from "@/components/TwitterShareButton.vue";
	import CommentButton from "@/components/CommentButton.vue";
	import CommentsModal from "@/components/CommentsModal.vue";

    const fb = require('../firebaseConfig.js')
    const increment = firebase.firestore.FieldValue.increment(1);

	export default {
		name: 'Home',
		title: 'Nepometer: A platform to voice your views',
		components: {
			Tinder: Tinder,
			MovieCard: MovieCard,
			SupportButton : SupportButton,
			AgainstButton : AgainstButton,
			TwitterShareButton : TwitterShareButton,
			CommentButton : CommentButton,
			CommentsModal : CommentsModal
		},
        computed: {
            ...mapState(['userProfile', 'currentUser', 'posts', 'hiddenPosts'])
        },
		data: function() {
			return {
				movies: [],
				dbmovies: [],
				imageBase: "https://image.tmdb.org/t/p/w1280",
				sortCriteria: "Release Date",
				sortedBy: "release_date",
				page: 1,
				totalPages: 1,
				showPagination: false,
				queue: [],
				offset: 0,
				history: [],
				buttonsActive: true,
				moviesMaxCount: 250,
				moreMoviesActive: false,
				lastMovie: null,
				currentCard: {id : null, type : null},
				twitterShare : { network: 'twitter', name: 'Twitter', icon: ['fab', 'twitter'], color: '#ffffff', url: 'https://nepometer.co.in', title: 'For rating Bollywood\'s rampant nepotism, visit', description: 'Nepometer: A platform to voice your views', quote: 'Swipe and raise your voice!', hashtags: 'nepotism,nepometer', twitterUser: 'Nepometer_IN'},
			};
		},
		methods: {
			loadCards(count = 5, append = true) {
				const list = [];
				for (let i = 0; i < count; i++) {
					if(typeof this.movies[this.offset] == 'undefined')
						continue
					list.push(this.movies[this.offset]);
					this.offset++;
				}
				if (append) {
					this.queue = this.queue.concat(list);
				} else {
					this.queue.unshift(...list);
				}
				this.setCurrentCard();
			},
			setCurrentCard() {
				let currentCard = this.currentCard;
				let firstCard = this.queue[0];
				if ((typeof firstCard['type'] !== 'undefined')) {
					currentCard['id'] = firstCard['id'];
					currentCard['type'] = firstCard['type'];
				}
				this.currentCard = Object.assign({}, currentCard);
				this.$store.dispatch('updateCurrentMovie', currentCard);
			},
			ratingSubmit({type, key, item}) {
				if (this.queue.length < 3) {
					this.loadCards();
				}
				this.history.push(item);
				if ((this.movies.length-this.offset <= 5) && (this.page < this.totalPages)) {
					this.page++;
				}
				this.decide(type);
				if (this.currentUser == null) {
					this.$router.push('/login');
					return;
				}
				if ((type != 'like') && (type != 'nope'))
					return;
				if (typeof item.type == 'undefined') {
					item.type = 'movie'
				}
				/* if (item.type == 'share')
					return; */
                var movie = Object.assign({}, item);
				this.dbRatingsInsert(type, movie)
			},
			dbRatingsInsert(type, movie) {
				var movieId = "" + movie.id;
				var ratingId = `${this.currentUser.uid}_${movieId}`;
        		if (type == 'like')
        			movie["nepometer"] = {"likes": 1, "nopes": 0};
        		else if (type == 'nope')
        			movie["nepometer"] = {"likes": 0, "nopes": 1};
        		else
        			return

				fb.ratingCollection.doc(ratingId).get()
				.then((doc) => {
					if (doc.exists) {
						return doc;
					} else {
						return fb.ratingCollection.doc(ratingId).set({
							userId : this.currentUser.uid,
							movieId : movieId,
							choice : type,
						});
					}
				})
				.then((result) => {
					return fb.movieCollection.doc(movieId).get();
				})
				.then((doc) => {
					if (doc.exists) {
						if (type == 'like') {
							return fb.movieCollection.doc(movieId).update({"nepometer.likes": increment});
						} else if(type == 'nope') {
							return fb.movieCollection.doc(movieId).update({"nepometer.nopes": increment});
						} else {
							return doc;
						}
					} else {
						return fb.movieCollection.doc(movieId).set(movie);
					}
				})
				.then((result) => {
				})
				.catch((err) => {
					console.error(err.message);
				})
			},
			getDBMovies() {
				fb.movieCollection.orderBy('release_date', 'desc').limit(this.moviesMaxCount+1).get().then(docs => {
					this.setMovieCollection(docs)
				});
			},
			getNextDBMovies() {
				if (this.lastMovie == null) {
					return;
				}
				fb.movieCollection.orderBy('release_date', 'desc').startAfter(this.lastMovie).limit(this.moviesMaxCount+1).get().then(docs => {
					this.setMovieCollection(docs)
				});
			},
			setMovieCollection(docs) {
				let moviesArray = [];
				this.moreMoviesActive = false;

				docs.forEach(doc => {
					let movie = doc.data();
					movie.type = 'movie';
					moviesArray.push(movie);
				});

				let moreMoviesAvailable = (moviesArray.length > this.moviesMaxCount);
				if (moreMoviesAvailable) {
					moviesArray.pop();
					this.moreMoviesActive = true;
					this.lastMovie = docs[docs.size-2];
					this.totalPages++;
				} else {
					this.lastMovie = null;
				}
				moviesArray = this.shuffleArray(moviesArray);
				/* if (typeof moviesArray[4] != 'undefined') moviesArray[4]['type'] = 'share';
				if (typeof moviesArray[14] != 'undefined') moviesArray[14]['type'] = 'share';
				if (typeof moviesArray[49] != 'undefined') moviesArray[49]['type'] = 'share'; */

				this.movies = this.movies.concat(moviesArray);
			},
			getMovies() {
				const key = process.env.VUE_APP_TMDB_APP_KEY;
				axios
					.get(
						"https://api.themoviedb.org/3/list/6125489?api_key=" +
							key +
							"&region=IN&page=" +
							this.page
					)
					.then(response => {
						// handle success
						//console.log(response);
						// this.totalPages = 1;//response.totalPages
						var m = response.data.items;
						for (var i=0; i<m.length; i++) {
							let movieId = ""+m[i].id, movie = Object.assign({}, m[i]);
							fb.movieCollection.doc(movieId).get().then(doc => {
								if (doc.exists) {
									var docMovie = doc.data()
									if(typeof docMovie.crew == 'undefined' || typeof docMovie.cast == 'undefined') {
										axios.get(
											"https://api.themoviedb.org/3/movie/" + movieId + "/credits?api_key=" +
												key
											)
											.then(response => {
												fb.movieCollection.doc(""+response.data.id).update({"cast":response.data.cast, "crew":response.data.crew});
											}).catch(err => {console.log(err);});
									}
									return;
								}
								axios.get(
									"https://api.themoviedb.org/3/movie/" + movieId + "/credits?api_key=" +
										key
									)
									.then(response => {
		        						movie["nepometer"] = {"likes": 0, "nopes": 0};
										movie["cast"] = response.data.cast;
										movie["crew"] = response.data.crew;
										fb.movieCollection.doc(movieId).set(movie).then(() => {
										}).catch(err => {console.log(err);});
									})
									.catch(err => {console.log(err);});
							}).catch(err => {console.log(err);});
						}
						// m = this.shuffleArray(m);
						// if (typeof m[4] != 'undefined') m[4]['type'] = 'share';
						// if (typeof m[14] != 'undefined') m[14]['type'] = 'share';
						// if (typeof m[49] != 'undefined') m[49]['type'] = 'share';
						// this.showPagination = true;
						// this.loadCards();

					})
					.catch(error => {
						// handle error
						console.log(error);
					})
					.finally(() => {
						// always executed
						console.log(this.movies)
					});
			},
			shuffleArray(array) {
				// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
				for (let i = array.length - 1; i > 0; i--) {
					const j = Math.floor(Math.random() * (i + 1));
					[array[i], array[j]] = [array[j], array[i]];
				}
				return array;
			},
			sortBy(prop, m) {
				if (prop === "popularity") {
					this.sortCriteria = "Most Popular";
				} else if (prop === "vote_average") {
					this.sortCriteria = "Highest Rated";
				} else if (prop === "release_date") {
					this.sortCriteria = "Release Date";
				}
				this.sortedBy = prop;
				if(typeof m === 'undefined')
					this.movies.sort((a, b) => (a[prop] > b[prop] ? -1 : 1));
				else {
					m.sort((a, b) => (a[prop] > b[prop] ? -1 : 1));
					return m;
				}
			},
			setupMoviesInDB() {
				this.dbmovies = []
				this.getMovies();
			},
			commentButtonClicked() {
				this.$store.dispatch('activateCommentsModal');
				this.$store.dispatch('fetchMovieComments', { id : this.currentCard.id })
			},
			async decide(choice) {
				if (choice === "rewind") {
					if (this.history.length) {
					  this.$refs.tinder.rewind([this.history.pop()]);
					}
				} else if (choice === "help") {
					console.log('Help triggered');
				} else {
					this.$refs.tinder.decide(choice);
					this.setCurrentCard();
				}
			}
		},
		watch: {
			page: function(page) {
				this.getNextDBMovies();
			},
			movies: function(movies) {
				this.loadCards();
			}
		},
		created() {
		},
		mounted() {
			this.getDBMovies();
			this.$store.dispatch('resetComments');
			// this.setupMoviesInDB(); // use in admin mode
		}
	};

</script>

<style scoped>
html,
body {
  height: 100%;
  overflow: hidden !important;
}

body {
  margin: 0;
  background-color: #20262e;
  overflow: hidden;
}

#app .vue-tinder {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 140px;
  margin: auto;
  width: calc(100% - 20px);
  height: calc(100% - 110px - 65px - 47px - 16px);
  min-width: 300px;
  max-width: 355px;
}

.box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 128px;
  height: 80px;
  margin: auto;
  border-radius: 20px;
}

.nope-pointer,
.like-pointer {
  position: absolute;
  z-index: 1;
  top: 0px;
  width: 100%;
  height: 100%;
}

.nope-pointer .box, .btn.nope {
  background: linear-gradient(135deg, #0B4D22 0%, #05411F 100%);
}

.like-pointer .box, .btn.like {
  background: linear-gradient(135deg, #5D172E 0%, #490D20 100%);
}

.btn.info {
  color:blue;
}

.super-pointer {
  position: absolute;
  z-index: 1;
  bottom: 80px;
  left: 0;
  right: 0;
  margin: auto;
  width: 112px;
  height: 78px;
}

.rewind-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  right: 10px;
  width: 112px;
  height: 78px;
}

.bottom-tray {
	position: absolute;
	left: 0;
	z-index: 10;
	right: 0;
	bottom: 0px;
	margin: auto;
	height: 70px;
	min-width: 300px;
	max-width: 355px;
}
.hidden {
	display: none;
}
</style>
